import theme from '@trmediaab/theme-travrondenspel';
import { BorderBox, Button, FlexBox } from '@trmediaab/zebra';

import { ThemedLink } from '../ThemedLink';

const VIEWS = {
  STARTLIST: 'startlista',
  TIPS: 'tips',
};

const sharedButtonStyles = {
  borderRadius: '2',
  height: '27px',
  justifyContent: 'center',
  alignItems: 'center',
  fontWeight: 'bold',
  fontSize: '1',
  width: '160px',
};

const TabButton = ({ isActive, betTypeColor, to, children }) => (
  <Button
    as={ThemedLink}
    to={to}
    color={isActive ? 'white !important' : `${betTypeColor} !important`}
    bg={isActive ? betTypeColor : undefined}
    sx={{
      '&:hover': {
        color: isActive ? 'white !important' : `${betTypeColor} !important`,
      },
    }}
    {...sharedButtonStyles}
  >
    {children}
  </Button>
);

const TabNavigation = ({ leg_number, bet_type, location, roundSlug }) => {
  const { betType } = theme.colors;
  const betTypeColor = betType[bet_type].bg;
  const currentView = location.payload.view;

  const createTabProps = view => ({
    to: {
      type: 'ROUND_TIP',
      payload: {
        bet_type,
        slug: roundSlug,
        leg_number,
        view,
      },
    },
    isActive: currentView === view,
    betTypeColor,
  });

  return (
    <FlexBox
      alignItems="center"
      justifyContent="center"
      py="2,5"
      bg="white"
      sx={{
        borderTop: '2px solid',
        borderColor: 'background.secondary',
      }}
    >
      <BorderBox
        height="35px"
        borderRadius="10px"
        display="flex"
        alignItems="center"
        backgroundColor="#ECECEC"
        px="1"
      >
        <TabButton {...createTabProps(VIEWS.STARTLIST)}>Startlista</TabButton>
        <TabButton {...createTabProps(VIEWS.TIPS)}>Tips</TabButton>
      </BorderBox>
    </FlexBox>
  );
};

export default TabNavigation;
